import { Component, defineComponent, onMounted, provide } from 'vue';
import NoResults from './NoResultsRecommendations.class';
import {
	DisciplineSuggestions,
	LocationSuggestions,
	SelectedFilters,
	FilterKey,
	FilterProviderKey,
	ISelectedFiltersOptions
} from '@studyportals/search-filters';
import FilterProvider from '../filters/FilterProvider';

export default defineComponent({
	components: {
		SelectedFilters: SelectedFilters as Component,
		DisciplineSuggestions: DisciplineSuggestions as Component,
		LocationSuggestions: LocationSuggestions as Component
	},
	setup: () => {
		provide(FilterProviderKey.FILTER_PROVIDER, FilterProvider.instance);
		provide(FilterProviderKey.LOCATION_FILTER_PROVIDER, FilterProvider.instance);

		const component = new NoResults();
		onMounted(component.mounted.bind(component));

		const selectedFiltersOptions: ISelectedFiltersOptions = {
			displayClearAll: false,
			collapseToDefaultNumberOfRows: false,
			displayTitle: false
		};

		return {
			dataIdentifier: component.dataIdentifier,
			selectedDiscipline: component.selectedDiscipline,
			countryFilterValues: component.countryFilterValues,
			disciplineFilterKey: FilterKey.DISCIPLINES,
			regionFilterKey: FilterKey.AREA,
			countryFilterKey: FilterKey.COUNTRY,
			continentFilterKey: FilterKey.CONTINENT,
			selectedFiltersOptions,
			pageTitle: component.pageTitle,
			resultsCount: component.resultsCount,
			maxNumberOfResultsForSuggestions: component.MAX_NUMBER_OF_RESULTS_FOR_SUGGESTIONS,
			trackingDisplaySection: 'suggestion'
		};
	}
});
